import React, { useMemo } from 'react';
import { useAppSelector } from 'src/utils/Hooks';
import { SearchSelect } from 'src/components/BeaconV2Components/ExperimentalLayout/Settings/Presentations/components/SearchSelect';
import { usePresentationFormContext } from 'src/components/BeaconV2Components/ExperimentalLayout/Settings/Presentations/PresentationFormContext';

const retailerIdsToExclude = new Set(['6', '35', '73', '74', '77', '90']);

export const RetailerSelect = () => {
  const {
    selections: { control }
  } = usePresentationFormContext();
  const { availableRetailers } = useAppSelector((state) => state.retailer);
  const {
    config: { allRetailerIds }
  } = useAppSelector((state) => state.user);

  const retailersData = useMemo(() =>
    availableRetailers.filter(
      (retailer) => !retailerIdsToExclude.has(retailer.id) && allRetailerIds.includes(Number(retailer.id))
    ), [availableRetailers, allRetailerIds]);

  const selectOptions = retailersData.map((datum) => {
    return { id: datum.id, value: datum.id.toString(), displayName: datum.displayName };
  });

  return (
    <SearchSelect
      name="retailerIds"
      title="Retailer Inclusions"
      placeholder="Search or select retailers you would like to add to your presentation (currencies will be normalized)"
      selectOptions={selectOptions}
      isMulti={true}
      control={control}
    />
  );
};
